import { useEffect } from 'react'

// Mantém a tela acesa enquanto o crachá está visível (ignora navegadores sem suporte)
export function useScreenWakeLock(active: boolean) {
	useEffect(() => {
		if (!active || !('wakeLock' in navigator)) return

		let sentinel: WakeLockSentinel | null = null
		let cancelled = false

		const request = async () => {
			try {
				const lock = await navigator.wakeLock.request('screen')
				if (cancelled) {
					await lock.release()
					return
				}
				sentinel = lock
			} catch {
				// Sem permissão ou aba em segundo plano: segue sem wake lock
			}
		}

		const handleVisibility = () => {
			if (document.visibilityState === 'visible') request()
		}

		request()
		document.addEventListener('visibilitychange', handleVisibility)

		return () => {
			cancelled = true
			document.removeEventListener('visibilitychange', handleVisibility)
			sentinel?.release().catch(() => {})
		}
	}, [active])
}
